import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import authentication from "@irati/auth"

const idNamespace = "secondaryNav"

interface Props {
  pathname: string
}

const MedicalSecondaryNavLinks = ({pathname}: Props) => {
  const hasAdminAccess = !!authentication.apps().admin
  const hasPermission = doIHavePermission(["medical"], authentication.apps())

  if (!hasAdminAccess || !hasPermission) return null

  return (
    <>
      <RouterLink id={id("link-my-medical", idNamespace)} to="/my-medical" className={pathname.includes("/my-medical") && "active"}>
        <FormattedMessage id="medical.navigation.myMedical" />
      </RouterLink>
      <RouterLink id={id("link-medical-reports", idNamespace)} to="/reports" className={pathname.includes("/reports") && "active"}>
        <FormattedMessage id="medical.navigation.reports" />
      </RouterLink>
    </>
  )
}

export default MedicalSecondaryNavLinks
